var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"inner row5"},[_c('article',{staticClass:"infoInner"},[_c('AdminUsrProfile')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }